export default {
  id: null,
  settlement_type_id: null,
  file_id: null,
  type_id: null,
  payment_type_id: null,
  currency: "PLN",
  amount_in_currency: null,
  bill_number: null,
  bill_description: null,
  bill_date: null,
  type: null,
  is_internal_cost: false,
  vehicle_type_id: null,
  is_invoice_for_employer: false,
  net_amount_in_currency: null
};
